import { Link, useNavigate } from "react-router-dom";
import "../../Styles/Loginpage/Loginpage.css";
import { useState, useEffect, useContext } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { PostCallWithErrorResponse } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { toast, ToastContainer } from "react-toastify"; 
import { AppContext } from "../../context/AppContext";

export default function LoginPageUsingEmailPass() {
  const navigate = useNavigate();
const {setCurrencySymbol, } =  useContext(AppContext);
  // Page Title and Favicon Update
  useEffect(() => {
    document.title = "Login | YellowCalf";
  }, []);

  const [formData, setFormData] = useState({
    username: "",
    password: "",
    device_id: "1223",
    device_os: "web",
    device_token: "1231",
    app_type: "web",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const togglePassword = () => setShowPassword((prev) => !prev);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const Userlogin = (e) => {
    e.preventDefault();

    if (!formData.username || !formData.password) {
      alert("Please enter both email and password");
      return;
    }

    setLoading(true);

    PostCallWithErrorResponse(ApiConfig.LOGIN, JSON.stringify(formData))
      .then((res) => {
        setLoading(false);

        if (res.json?.result) {
          const data = res.json;

          localStorage.setItem("api_key", data.api_key);
          localStorage.setItem("user_id", data.user_id);
          localStorage.setItem("user_details", JSON.stringify(data.user));
          localStorage.setItem("username", JSON.stringify(data.user.user_name));
          localStorage.setItem("customer_currency", data.customer_currency.currency_symbol);
          setCurrencySymbol(data.customer_currency.currency_symbol);
          localStorage.setItem("customer_id", data.customer_id);
          localStorage.setItem("customer_name", data.customer_first_name);
          localStorage.setItem("user_role", data.user.user_role);
          localStorage.setItem("isLoggedIn", "true");

          toast.success("Login successful");

          setTimeout(() => {
            navigate("/accountant", { replace: true });
          }, 1000);
        } else {
          toast.error(res.json?.message || "Login failed");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error("Login Error:", err);
        toast.error("An error occurred during login");
      });
  };

  return (
    <div className="center-page">
      <ToastContainer />
      <div className="login-card id-pass-login">
        <img
          src="/static/media/logo.25ae0241f5bf7d7c5384da9376d392bc.svg"
          alt="Logo"
          className="login-logo"
        />

        <h4>Sign in to your account</h4>
        <hr className="divider" />

        <form onSubmit={Userlogin}>
          <div className="form-group">
            <input
              type="email"
              name="username"
              className="form-control"
              placeholder="Email ID"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <div className="login-password-wrap">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="form-control"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <span className="password-toggle-icon" onClick={togglePassword}>
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            <div className="login-forgot-row">
              <Link to="/forgotpassword" className="forgot-password">
                Forgot password?
              </Link>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn custom-btn main-login"
          >
            {loading ? "Signing in..." : "Login"}{" "}
            <i className="bi bi-arrow-right-circle"></i>
          </button>
        </form>

        <p className="text-center small">2026 © YellowCalf</p>
      </div>
    </div>
  );
}